import { render, staticRenderFns } from "./ManuscriptEditor.vue?vue&type=template&id=7dd54f06&scoped=true&"
import script from "./ManuscriptEditor.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptEditor.vue?vue&type=style&index=0&id=7dd54f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd54f06",
  null
  
)

export default component.exports